import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "../../css/DashBoard.css";
import "../../css/assessment.css";
import MCQ from "../questions/MCQComponent";
import TrueOrFalse from "../questions/TrueOrFalse";
import OrderComponent from "../questions/OrderComponent";
import MatchQComponent from "../questions/MatchQComponent";
import EssayComponent from "../questions/EssayComponent";
import AudioComponent from "../questions/AudioComponent";
import LabelQComponent from "../questions/LabelQComponent";
import ImageHighlightComponent from "../questions/ImageHighlightComponent";
import FileUploadEnhanced from "../questions/FileUploadEnhanced";
import FillTheBlank from "../questions/FillTheBlank";
import VideoComponent from "../questions/VideoComponent";
import "react-responsive-modal/styles.css";
import Loader from "react-loader-spinner";
import Swal from "sweetalert2";
import MultiStepFunc from "../../hooks/MultiStepFunc";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../variables/api";
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router-dom";
import ProcessCardSingleState from "../questions/ProcessCardSingleState";
import { MathJax } from "better-react-mathjax";
import { Router } from "react-router";
import { routerActions } from "connected-react-router";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

import * as Bowser from "bowser";
const StudentAssessment = (props: any) => {
  const searchParams: any = new URLSearchParams(location.search);
  const history = useHistory();
  let id = searchParams.get("hash");
  const [state, setState] = useState<any>({
    isInite: true,
    exam_start: false,
    tryTosubmit: false,
    assessment: null,
    questions: [],
  });
  const [applicationDeviceInfo, setApplicationDeviceInfo] = useState<any>(null);
  const examMode = "examMode";
  const buttonRef = useRef<any>();
  const examContainerRef = useRef<any>();
  const [countHasfinished, setCountHasFinished] = useState(false);
  const stateRef = useRef(state);

  // useEffect(() => {
  //   getFingerprint().then(fingerprint => {
  //     console.log("Fingerprint:", fingerprint);
  //   })
  // }, []);

  function base64ToString(b64: any) {
    const binary = atob(b64);
    let percent = "";
    for (let i = 0; i < binary.length; i++) {
      percent += "%" + ("00" + binary.charCodeAt(i).toString(16)).slice(-2);
    }
    return decodeURIComponent(percent);
  }

  const getCurrentUserName = () => {
    try {
      const token = Cookies.get("tokentest");
      if (token) {
        const decodedToken: any = jwt_decode(token);
        return decodedToken?.data?.data?.userName || "";
      }
    } catch (error) {
      console.error("Error getting username:", error);
    }
    return "";
  };

  const showDesktopAppRequiredModal = (platform?: string) => {
    const urlParams = new URLSearchParams(window.location.search);
    const hash = urlParams.get("hash");

    if (!hash) {
      Swal.fire({
        icon: "error",
        title: "Missing Information",
        text: "Required exam information is missing. Please access the exam from your LMS.",
        allowOutsideClick: false,
      }).then(() => {
        window.close();
      });
      return;
    }

    // Determine download link based on platform
    let downloadLink = "";
    let downloadLinkMacOS = ""; // For Mac, we'll have a second link
    let platformName = "";
    let isMacPlatform = false;

    if (!platform) {
      // Detect platform if not provided
      const userAgent = navigator.userAgent.toLowerCase();
      if (/android/.test(userAgent)) {
        platform = "android";
      } else if (/iphone|ipad|ipod/.test(userAgent)) {
        platform = "ios";
      } else if (/windows|win32|win64/.test(userAgent)) {
        platform = "windows";
      } else if (/mac/.test(userAgent) && !/iphone|ipad|ipod/.test(userAgent)) {
        platform = "mac";
      }
    }

    switch (platform) {
      case "android":
        downloadLink =
          "https://play.google.com/store/apps/details?id=com.ivystem.assessments";
        platformName = "Android";
        break;
      case "ios":
        downloadLink = "https://apps.apple.com/eg/app/assessgo/id6749691670";
        platformName = "iOS";
        break;
      case "mac":
        downloadLink = "https://apps.apple.com/eg/app/assessgo/id6749691670"; // iOS App Store
        downloadLinkMacOS =
          "https://cdn-spark.s3.us-east-2.amazonaws.com/desktopexam/AssessGO+2.dmg"; // macOS dmg
        platformName = "macOS";
        isMacPlatform = true;
        break;
      case "windows":
        downloadLink =
          "https://cdn-spark.s3.us-east-2.amazonaws.com/desktopexam/AssessGO+Setup+4.0.0.exe";
        platformName = "Windows";
        break;
      default:
        downloadLink =
          "https://cdn-spark.s3.us-east-2.amazonaws.com/desktopexam/AssessGO+Setup+4.0.0.exe";
        platformName = "your device";
    }

    // Build the exam link URL
    const examLinkUrl = `${window.location.origin}/assessment?hash=${hash}`;

    // Get username for deep link
    const username = getCurrentUserName();
    // console.log("Deep link username:", username);

    // Build the deep link with the storecookie.php endpoint
    // Format: assessgo://q.ivyis.org/backend/include/storecookie.php?username=...&examLink=...
    const deepLink = `assessgo://${BASE_URL}include/storecookie.php?&examLink=${examLinkUrl}`;

    // console.log("Deep link:", deepLink);

    Swal.fire({
      title: "AssessGo App Required",
      html: `
        <div style="text-align: center;">
          <div style="font-size: 64px; margin-bottom: 20px;">🔒</div>
          <p style="font-size: 16px; color: #666; margin-bottom: 20px;">
            This exam must be opened through the AssessGo application.
          </p>
          <p style="font-size: 14px; color: #999;">
            Click the button below to open the exam in the AssessGo app.
          </p>
        </div>
      `,
      icon: "warning",
      showCancelButton: !isMacPlatform,
      showDenyButton: isMacPlatform,
      confirmButtonText:
        '<i class="fas fa-external-link-alt"></i> Open in AssessGo App',
      cancelButtonText: isMacPlatform
        ? ""
        : '<i class="fas fa-download"></i> Download App',
      denyButtonText: isMacPlatform
        ? '<i class="fab fa-apple"></i> Download for iOS'
        : "",
      confirmButtonColor: "#074e9a",
      cancelButtonColor: "#28a745",
      denyButtonColor: "#007aff",
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        actions: isMacPlatform ? "swal2-actions-mac" : "",
      },
      didOpen: () => {
        // Add custom styling for Mac layout
        if (isMacPlatform) {
          const actionsContainer = document.querySelector(".swal2-actions");
          if (actionsContainer) {
            (actionsContainer as HTMLElement).style.cssText = `
              display: flex !important;
              flex-direction: column !important;
              gap: 10px !important;
              width: 100%;
            `;

            // Create a button container for the two download buttons
            const denyButton = document.querySelector(".swal2-deny");
            const confirmButton = document.querySelector(".swal2-confirm");

            if (denyButton && confirmButton) {
              // Create a wrapper for download buttons
              const downloadWrapper = document.createElement("div");
              downloadWrapper.style.cssText = `
                display: flex;
                gap: 10px;
                width: 100%;
                margin-top: 10px;
              `;

              // Create macOS download button
              const macButton = document.createElement("button");
              macButton.className = "swal2-styled";
              macButton.style.cssText = `
                background-color: #5e5e5e !important;
                flex: 1;
              `;
              macButton.innerHTML =
                '<i class="fab fa-apple"></i> Download for macOS';
              macButton.onclick = () => {
                window.open(downloadLinkMacOS, "_blank");
                setTimeout(() => showDesktopAppRequiredModal(platform), 1000);
              };

              downloadWrapper.appendChild(denyButton.cloneNode(true));
              downloadWrapper.appendChild(macButton);

              // Replace the deny button with the wrapper
              denyButton.replaceWith(downloadWrapper);

              // Update the iOS button click handler
              const iosButton = downloadWrapper.querySelector(".swal2-deny");
              if (iosButton) {
                iosButton.addEventListener("click", (e) => {
                  e.preventDefault();
                  window.open(downloadLink, "_blank");
                  setTimeout(() => showDesktopAppRequiredModal(platform), 1000);
                });
              }
            }
          }
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Try to open the desktop app
        window.location.href = deepLink;

        // Show a follow-up message after a delay
        setTimeout(() => {
          Swal.fire({
            title: "App Not Opening?",
            html: `
              <p>If the AssessGo app didn't open automatically, you may need to:</p>
              <ol style="text-align: left; padding-left: 20px;">
                <li>Install the AssessGo application</li>
                <li>Make sure the app is not already running</li>
                <li>Try clicking "Open in AssessGo App" again</li>
              </ol>
            `,
            icon: "info",
            showCancelButton: !isMacPlatform,
            showDenyButton: isMacPlatform,
            confirmButtonText: "Try Again",
            cancelButtonText: isMacPlatform ? "" : "Download App",
            denyButtonText: isMacPlatform
              ? '<i class="fab fa-apple"></i> Download for iOS'
              : "",
            confirmButtonColor: "#074e9a",
            cancelButtonColor: "#28a745",
            denyButtonColor: "#007aff",
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
              // Add custom styling for Mac layout in retry modal
              if (isMacPlatform) {
                const actionsContainer =
                  document.querySelector(".swal2-actions");
                if (actionsContainer) {
                  (actionsContainer as HTMLElement).style.cssText = `
                    display: flex !important;
                    flex-direction: column !important;
                    gap: 10px !important;
                    width: 100%;
                  `;

                  const denyButton = document.querySelector(".swal2-deny");
                  const confirmButton =
                    document.querySelector(".swal2-confirm");

                  if (denyButton && confirmButton) {
                    const downloadWrapper = document.createElement("div");
                    downloadWrapper.style.cssText = `
                      display: flex;
                      gap: 10px;
                      width: 100%;
                      margin-top: 10px;
                    `;

                    const macButton = document.createElement("button");
                    macButton.className = "swal2-styled";
                    macButton.style.cssText = `
                      background-color: #5e5e5e !important;
                      flex: 1;
                    `;
                    macButton.innerHTML =
                      '<i class="fab fa-apple"></i> Download for macOS';
                    macButton.onclick = () => {
                      window.open(downloadLinkMacOS, "_blank");
                      setTimeout(
                        () => showDesktopAppRequiredModal(platform),
                        1000,
                      );
                    };

                    downloadWrapper.appendChild(denyButton.cloneNode(true));
                    downloadWrapper.appendChild(macButton);

                    denyButton.replaceWith(downloadWrapper);

                    const iosButton =
                      downloadWrapper.querySelector(".swal2-deny");
                    if (iosButton) {
                      iosButton.addEventListener("click", (e) => {
                        e.preventDefault();
                        window.open(downloadLink, "_blank");
                        setTimeout(
                          () => showDesktopAppRequiredModal(platform),
                          1000,
                        );
                      });
                    }
                  }
                }
              }
            },
          }).then((retryResult) => {
            if (retryResult.isConfirmed) {
              window.location.href = deepLink;
              // Show modal again after trying to open app
              setTimeout(() => showDesktopAppRequiredModal(platform), 3000);
            } else if (retryResult.dismiss === Swal.DismissReason.cancel) {
              // Open download link
              window.open(downloadLink, "_blank");
              // Show modal again after download
              setTimeout(() => showDesktopAppRequiredModal(platform), 1000);
            } else {
              // Any other dismiss reason (like backdrop click) - show modal again
              showDesktopAppRequiredModal(platform);
            }
          });
        }, 3000);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // Download the app
        window.open(downloadLink, "_blank");
        // Show modal again after user clicks cancel/download
        setTimeout(() => showDesktopAppRequiredModal(platform), 1000);
      } else {
        // Any other dismiss reason - show modal again
        showDesktopAppRequiredModal(platform);
      }
    });
  };

  useEffect(() => {
    $("#preloader").hide();

    // Note: Froala assets are now loaded via event listener in App.tsx
    // React Native triggers 'loadRichBox' event when ready

    // Detect platform
    const detectPlatform = () => {
      const userAgent = navigator.userAgent.toLowerCase();

      if (/windows|win32|win64/.test(userAgent)) {
        return "windows";
      }

      if (/android/.test(userAgent)) {
        return "android";
      }

      if (/iphone|ipad|ipod/.test(userAgent)) {
        return "ios";
      }

      if (/mac/.test(userAgent)) {
        return "mac";
      }

      if (/linux/.test(userAgent)) {
        return "linux";
      }

      return "other";
    };

    // Secure random nonce generator using crypto API
    const generateSecureNonce = (length: number = 32): string => {
      const array = new Uint8Array(length);
      if (typeof crypto !== "undefined" && crypto.getRandomValues) {
        crypto.getRandomValues(array);
      } else {
        // Fallback for older environments
        for (let i = 0; i < length; i++) {
          array[i] = Math.floor(Math.random() * 256);
        }
      }
      return Array.from(array, (byte) =>
        byte.toString(16).padStart(2, "0"),
      ).join("");
    };

    // Convert number to string safely for PHP compatibility
    // PHP and JS handle large integers differently - using strings ensures consistency
    const toSafeNumberString = (num: number): string => {
      // Ensure we don't lose precision for large numbers
      return num.toString(10);
    };

    // Compute secure hash using djb2 algorithm - simple and consistent between JS and PHP
    const computeSecureHash = (data: string, key: string): string => {
      const input = `${key}:${data}`;

      // djb2 hash algorithm - simple and consistent
      let hash1 = 5381;
      let hash2 = 5381;

      for (let i = 0; i < input.length; i++) {
        const c = input.charCodeAt(i);
        // hash * 33 + c
        hash1 = ((hash1 << 5) + hash1 + c) >>> 0;
        hash2 = ((hash2 << 5) + hash2 + (c ^ 0x5a)) >>> 0;
      }

      // Combine into 16 char hex
      const hex1 = (hash1 >>> 0).toString(16).padStart(8, "0");
      const hex2 = (hash2 >>> 0).toString(16).padStart(8, "0");
      return hex1 + hex2;
    };

    // Collect browser fingerprint components
    const collectFingerprint = (): Record<string, string> => {
      return {
        ua: navigator.userAgent || "",
        lang: navigator.language || "",
        plat: navigator.platform || "",
        scr: `${screen.width}x${screen.height}x${screen.colorDepth || 24}`,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
        cores: toSafeNumberString(navigator.hardwareConcurrency || 0),
        touch: toSafeNumberString(navigator.maxTouchPoints || 0),
      };
    };

    // Hash fingerprint to fixed-length string (privacy + consistency)
    const hashFingerprint = (fp: Record<string, string>): string => {
      const fpString = Object.entries(fp)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([k, v]) => `${k}=${v}`)
        .join("|");

      // Use first 16 chars of hash for fingerprint
      return computeSecureHash(fpString, "fp").substring(0, 16);
    };

    // Stage 2: Compute final token with browser fingerprinting and HMAC-like signature
    // Desktop app provides: scrambled, h (tsHigh), and platform
    // Backend uses h to deterministically reverse the scramble
    const computeFinalToken = (stage1: any): string => {
      // Validate stage1 input - requires scrambled, h, and platform
      if (
        !stage1 ||
        typeof stage1.scrambled === "undefined" ||
        typeof stage1.h === "undefined"
      ) {
        throw new Error("Invalid stage1 input - missing scrambled or h");
      }

      // Generate cryptographically secure nonce
      const nonce = generateSecureNonce(16);

      // Get current timestamp as string for PHP compatibility
      const timestamp = Date.now();
      const timestampStr = toSafeNumberString(timestamp);

      // Collect and hash fingerprint
      const fingerprintData = collectFingerprint();
      const fingerprintHash = hashFingerprint(fingerprintData);

      // Get platform from stage1 (or detect it ourselves as fallback)
      const platform = stage1.platform || "unknown";

      // Payload: scrambled + h (tsHigh) + platform from desktop app
      // Backend uses h to deterministically reverse the scramble
      const payload = {
        s: toSafeNumberString(stage1.scrambled), // scrambled value as string
        h: toSafeNumberString(stage1.h), // tsHigh for deterministic reversal
        p: platform, // platform from desktop app
        n: nonce, // cryptographic nonce
        t: timestampStr, // token generation timestamp as string
        f: fingerprintHash, // hashed fingerprint (fixed length, privacy-safe)
      };

      // Create signature input - deterministic ordering
      const signatureData = [
        payload.s,
        payload.h,
        payload.p,
        payload.n,
        payload.t,
        payload.f,
      ].join(":");

      // Compute HMAC-like signature using scrambled value as key
      const signature = computeSecureHash(signatureData, payload.s);

      // Final signed payload
      const signedPayload = {
        ...payload,
        sig: signature,
      };

      // Convert to JSON with consistent key ordering for reproducibility
      const orderedPayload = {
        s: signedPayload.s,
        h: signedPayload.h,
        p: signedPayload.p,
        n: signedPayload.n,
        t: signedPayload.t,
        f: signedPayload.f,
        sig: signedPayload.sig,
      };

      const jsonString = JSON.stringify(orderedPayload);

      // Base64url encode (URL-safe, no padding)
      const base64 = btoa(jsonString)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");

      return base64;
    };

    // Check if opened from desktop app and verify token
    const checkDesktopApp = async () => {
      // Check if AssessGoString exists
      const assessGoString = (window as any)?.assessgo?.AssessGoString;
      const applicationDevceInfo = (window as any)?.assessgo?.deviceFingerPrint;

      // const applicationVersion = (window as any)?.assessgo?.applicationVersion;
      // const applicationType = (window as any)?.assessgo?.applicationType;

      // console.log("systemBrightnessAndAudiochanged:",systemBrightnessAndAudiochanged);

      // console.log(
      //   "🔍 checkDesktopApp - Raw deviceFingerPrint:",
      //   applicationDevceInfo
      // );
      // console.log("🔍 checkDesktopApp - Type:", typeof applicationDevceInfo);

      if (applicationDevceInfo) {
        try {
          // Parse if it's a string, otherwise use as-is
          const deviceInfoObject =
            typeof applicationDevceInfo === "string"
              ? JSON.parse(applicationDevceInfo)
              : applicationDevceInfo;
          // console.log("✅ Parsed deviceFingerPrint:", deviceInfoObject);
          setApplicationDeviceInfo(deviceInfoObject);
        } catch (error) {
          console.error("❌ Error parsing deviceFingerPrint:", error);
        }
      }
      if (!assessGoString) {
        return false;
      }

      try {
        // Parse the JSON string if it's a string, otherwise use as-is
        let stage1Data;
        if (typeof assessGoString === "string") {
          stage1Data = JSON.parse(assessGoString);
        } else {
          stage1Data = assessGoString;
        }

        // Compute the final token using the parsed stage1 data
        const finalToken = computeFinalToken(stage1Data);

        //console.log("Final Token Generated:", finalToken);

        // Prepare the payload to send to backend
        const screenRes = `${screen.width}x${screen.height}`;
        const payload = {
          token: finalToken,
          screenRes: screenRes,
          stage1Data: stage1Data, // Include for debugging/logging
        };

        // Return true if we successfully computed the token
        return true;
      } catch (error) {
        console.error("Error computing final token:", error);

        const errorMessage =
          error instanceof Error ? error.message : "Unknown error occurred";

        await Swal.fire({
          title: "Token Error",
          html: `<div style="text-align: left;">
                   <p><strong>Failed to compute desktop app token</strong></p>
                   <p style="color: #dc3545; margin-top: 10px;">Error: ${errorMessage}</p>
                 </div>`,
          icon: "error",
          confirmButtonText: "Continue",
        });

        return false;
      }
    };

    const platform = detectPlatform();

    // Compute token from desktop app data if available
    const getDesktopToken = (): string | null => {
      try {
        const assessGoString = (window as any)?.assessgo?.AssessGoString;
        // console.log("getDesktopToken - assessGoString:", assessGoString);

        if (!assessGoString) {
          //  console.log("getDesktopToken - No assessGoString found");
          return null;
        }

        let stage1Data;
        if (typeof assessGoString === "string") {
          stage1Data = JSON.parse(assessGoString);
        } else {
          stage1Data = assessGoString;
        }

        //console.log("getDesktopToken - stage1Data:", stage1Data);

        // Compute the final token
        const token = computeFinalToken(stage1Data);
        //     console.log("getDesktopToken - computed token:", token);
        return token;
      } catch (error) {
        //   console.error("Error computing desktop token:", error);
        Swal.fire({
          title: "something went wrong",
          text: "please make sure you are using the latest assessgo version",
        });
        return null;
      }
    };

    // First, check if the exam is secured
    axios
      .get(`${BASE_URL}externaluser/admin/getIsExamSecured.php?hash=${id}`)
      .then(async (securityRes) => {
        const isSecured = securityRes.data.data === "1";

        // Enforce desktop app requirement for all secured exams
        if (isSecured) {
          // Check for desktop app on Windows, Android, iOS, and Mac
          if (
            platform === "windows" ||
            platform === "android" ||
            platform === "ios" ||
            platform === "mac"
          ) {
            const isFromDesktopApp = await checkDesktopApp();

            if (!isFromDesktopApp) {
              // User not using AssessGo app - show modal
              showDesktopAppRequiredModal(platform);
              return; // Don't load the exam
            }
          }
        }

        // Continue loading the exam (either not secured OR from desktop app)
        // Get the desktop token if available (will be verified by backend for secured exams)
        const desktopToken = getDesktopToken();
        await loadExam(desktopToken);
      })
      .catch(async (err) => {
        console.error("Error checking exam security:", err);
        // If security check fails, still try to load the exam with token if available
        const desktopToken = getDesktopToken();
        // console.log("Security check failed, loading exam with token:", desktopToken);
        await loadExam(desktopToken);
      });

    const loadExam = async (token: string | null) => {
      // Build request payload - include token for secured exam verification
      const requestPayload: any = { id: id };
      const fingerprint = await getFingerprint();
      requestPayload.fingerprint = fingerprint;

      if (token) {
        requestPayload.token = token;
      }

      // console.log("loadExam - token received:", token);
      // console.log("loadExam - requestPayload:", requestPayload);

      // Get application info from window (set by Electron app)
      const applicationVersion = (window as any).applicationVersion;
      const applicationType = (window as any).applicationType;
      // console.log("[StudentAssessment] Application Version:", applicationVersion);
      // console.log("[StudentAssessment] Application Type:", applicationType);

      // Add to request payload if available
      if (applicationType) {
        requestPayload.applicationType = applicationType;
      }
      if (applicationVersion) {
        requestPayload.applicationVersion = applicationVersion;
      }

      // Build URL
      const url = `${BASE_URL}admin/getstudentexam.php`;

      axios
        .post(url, requestPayload)
        .then((res) => {
          // Check if the backend rejected the request (e.g., secured exam without valid token)
          if (res.data.status === "failed") {
            // Check if this is a secured exam rejection
            const errorMessage = res.data.msg || "";
            if (errorMessage.toLowerCase().includes("assessgo")) {
              // Show the AssessGo app required modal
              const detectedPlatform = detectPlatform();
              showDesktopAppRequiredModal(detectedPlatform);
              return;
            }

            // Other error - show generic error modal
            Swal.fire({
              icon: "info",
              title: "Error!",
              html: errorMessage,
              allowOutsideClick: false,
              showConfirmButton: true,
            }).then(() => {
              window.close();
            });
            return;
          }

          const assessmentData = res.data.data;

          let ExamStatus = localStorage.getItem("key");
          if (assessmentData != null) {
            // Use assessmentData instead of assessment
            setState((x: any) => ({
              ...x,
              assessment: assessmentData,
              questions: [], // Questions will be loaded after exam starts for security
            }));

            if (assessmentData.status === "Submitted") {
              Swal.fire({
                icon: "error",
                title: "Error!",
                html: "You have submitted this test before!<br>Please close the browser.",
                allowOutsideClick: false,
                showConfirmButton: true,
                showCancelButton: false,
              }).then((x: any) => {
                window.close();
              });
            } else if (
              assessmentData.status === "Started" &&
              assessmentData.issecured === "1" &&
              state.isInite
            ) {
              Swal.fire({
                icon: "info",
                title: "info!",
                html: `You have started this assessment before and this assessment is secured 
                    so if you want to open again ask your teacher `,
                allowOutsideClick: false,
                showConfirmButton: true,
                showCancelButton: false,
              }).then((x: any) => {
                window.close();
              });
            } else if (assessmentData.status === "Pending") {
              const examInfoHTML = `<h4>
                You are taking exam:  <span style="font-weight:bold;">${assessmentData?.name}</span>
                </h4><br>`;
              const isSecuredHTML =
                assessmentData?.issecured === "1"
                  ? `<h4>This is a secured exam any attempt to leave the page will be detected and will submit exam right away</h4>
                    <br>`
                  : ``;
              const isTimedHTML =
                assessmentData?.istimed === "1"
                  ? `<h4>This is a timed exam</h4>
                    <br>
                    <h4>Duration : <span style="font-weight:bold;">${assessmentData?.duration} minutes</span></h4>
                    <br>`
                  : ``;
              const numberOfQuestions = assessmentData?.questionCount
                ? `<h4>Number Of Questions : <span style="font-weight:bold;">${assessmentData?.questionCount}  Questions</span></h4>
                    <br>`
                : ``;
              Swal.fire({
                title: "Are you ready?",
                html: `${examInfoHTML}${isSecuredHTML}${isTimedHTML}${numberOfQuestions}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, I am ready!",
                allowOutsideClick: false,
                didOpen: () => {
                  const confirmButton = Swal.getConfirmButton();
                  if (confirmButton) {
                    confirmButton.id = "examStartButton";
                  }
                },
              }).then((result) => {
                if (result.isConfirmed) {
                  window.addEventListener("blur", () => {
                    if (assessmentData.issecured == "1") {
                      silentSubmitExam(stateRef?.current);
                    }
                  });
                  window.addEventListener("visibilitychange", () => {
                    if (assessmentData.issecured == "1") {
                      // Check if user is using desktop app
                      const assessGoString = (window as any)?.assessgo
                        ?.AssessGoString;
                      const expectedString =
                        process.env.REACT_APP_ASSESSGORANDOMSTRING;
                      const isFromDesktopApp =
                        assessGoString === expectedString;

                      if (!isFromDesktopApp) {
                        // Detect platform for correct download link
                        const userAgent = navigator.userAgent.toLowerCase();
                        let detectedPlatform = "windows";
                        if (/android/.test(userAgent)) {
                          detectedPlatform = "android";
                        } else if (/iphone|ipad|ipod/.test(userAgent)) {
                          detectedPlatform = "ios";
                        } else if (
                          /mac/.test(userAgent) &&
                          !/iphone|ipad|ipod/.test(userAgent)
                        ) {
                          detectedPlatform = "mac";
                        } else if (/windows|win32|win64/.test(userAgent)) {
                          detectedPlatform = "windows";
                        }

                        // Show modal to install app with correct platform
                        showDesktopAppRequiredModal(detectedPlatform);
                      } else {
                        // If in desktop app, submit exam as before
                        silentSubmitExam(stateRef?.current);
                      }
                    }
                  });
                  handleFullScreenClick();
                  if (
                    ExamStatus === null ||
                    (ExamStatus !== id &&
                      getMinutes() === 0 &&
                      getSeconds() === 0)
                  ) {
                    localStorage.setItem("key", id);
                    if (assessmentData?.istimed === "1") {
                      SetTimer(parseInt(assessmentData.duration));
                    }
                  } else {
                    let fexam = localStorage.getItem("fexam");
                    if (fexam === id) {
                      localStorage.setItem("fexam", "");
                    }
                  }

                  StudentStartExam(assessmentData);
                  examContainerRef.current.classList.remove("hide-element");
                  setState((x: any) => ({ ...x, exam_start: true }));
                } else {
                  window.opener = null;
                  window.close();
                }
              });
            } else if (assessmentData.status === "Graded") {
              Swal.fire({
                icon: "error",
                title: "Error!",
                html: "You have submitted this test before!<br>Please close the browser.",
                allowOutsideClick: false,
                showConfirmButton: true,
                showCancelButton: false,
              }).then(() => {
                window.close();
              });
            }
          }

          document.addEventListener("fullscreenchange", (e) => {
            if (assessmentData.issecured == "1") {
              e.preventDefault();
              if (document.fullscreenElement) {
              } else {
                Swal.fire({
                  title: "Warning?",
                  html: `You are leaving full screen mode this will cause the exam to be submitted<br>click back to full screen to avoid that`,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes, Get Back To Full Screen!",
                }).then((result) => {
                  console.log("result", result);
                  if (result.isConfirmed) {
                    handleFullScreenClick();
                  } else {
                    silentSubmitExam(stateRef?.current);
                  }
                });
              }
            }
          });
        })
        .catch((error) => {
          // Handle network errors or server errors
          console.error("Error loading exam:", error);

          // Check if the error response contains the AssessGo message
          const errorMessage = error?.response?.data?.msg || "";
          if (errorMessage.toLowerCase().includes("assessgo")) {
            const detectedPlatform = detectPlatform();
            showDesktopAppRequiredModal(detectedPlatform);
            return;
          }

          // Show generic error for other failures
          Swal.fire({
            icon: "info",
            title: "Error!",
            // text:JSON.stringify(error),
            html:
              errorMessage ||
              " An error occurred while loading the exam. Please try again later.",
            allowOutsideClick: false,
            showConfirmButton: true,
          });
        });
    };
  }, [countHasfinished]);

  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  // Track questions changes and update window.questionsPayload
  useEffect(() => {
    if (state.questions && state.questions.length > 0) {
      (window as any).questionsPayload = state.questions;
      console.log(
        "🔄 questionsPayload synced (state change):",
        (window as any).questionsPayload,
      );
      console.log("🔄 Total questions in state:", state.questions.length);
    }
  }, [state.questions]);

  // Monitor system brightness and audio changes from Electron app
  useEffect(() => {
    let hasSubmitted = false; // Prevent duplicate submissions
    let pollingInterval: NodeJS.Timeout | null = null;
    let isSubmitting = false; // Lock to prevent race conditions

    const submitBrightnessAudioAnomaly = async (data: any) => {
      // Check both hasSubmitted and isSubmitting to prevent race conditions
      if (hasSubmitted || isSubmitting) {
        return;
      }

      if (!state.exam_start) {
        return;
      }

      try {
        isSubmitting = true; // Set lock immediately
        hasSubmitted = true; // Set flag immediately

        // Clear the window flag to prevent re-triggering
        delete (window as any).systemBrightnessAndAudiochanged;

        // Stop polling immediately
        if (pollingInterval) {
          clearInterval(pollingInterval);
          pollingInterval = null;
        }

        // Remove event listeners immediately
        window.removeEventListener(
          "systemBrightnessAndAudiochanged",
          handleBrightnessAndAudioChange,
        );
        delete (window as any).onSystemBrightnessAndAudioChanged;

        const body = {
          studentexamid: id,
          event_type: "brightness_or_audio_anomaly",
          reason:
            "System brightness or audio settings changed during the exam frequently, which may indicate potential cheating behavior.",
        };

        await axios.post(`${BASE_URL}admin/submitcheatlog.php`, body);
      } catch (error) {
        console.error("Error submitting brightness/audio anomaly:", error);
        // Don't reset flags on error to prevent multiple retries
      } finally {
        isSubmitting = false;
      }
    };

    const handleBrightnessAndAudioChange = async (event: any) => {
      const detail = event.detail || {};
      await submitBrightnessAudioAnomaly(detail);
    };

    // Check if flag was already set by Electron
    const checkExistingFlag = async () => {
      const flag = (window as any)?.systemBrightnessAndAudiochanged;
      const data = (window as any)?.systemBrightnessAndAudioData;

      if (flag) {
        await submitBrightnessAudioAnomaly(data || {});
        return true;
      }
      return false;
    };

    // Listen for the custom event dispatched by Electron
    window.addEventListener(
      "systemBrightnessAndAudiochanged",
      handleBrightnessAndAudioChange,
    );

    // Also set up the callback function that Electron tries to call directly
    (window as any).onSystemBrightnessAndAudioChanged = async (data: any) => {
      await submitBrightnessAudioAnomaly(data);
    };

    // Start polling when exam starts
    if (state.exam_start) {
      checkExistingFlag();

      // Poll every second to check for the flag
      pollingInterval = setInterval(async () => {
        if (!hasSubmitted && !isSubmitting) {
          await checkExistingFlag();
        }
      }, 1000);
    }

    return () => {
      window.removeEventListener(
        "systemBrightnessAndAudiochanged",
        handleBrightnessAndAudioChange,
      );
      delete (window as any).onSystemBrightnessAndAudioChanged;
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };
  }, [state.exam_start, id]);

  const handleFullScreenClick = () => {
    const disableFullscreen = (window as any)?.assessgo?.disableFullscreen;
    const elem: any = document.documentElement;
    if (disableFullscreen) {
      return;
    }
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };

  const StudentSubmiteExam = async (data: any) => {
    const fingerprint = await getFingerprint();
    data.fingerprint = fingerprint;
    const loading = () => {
      Swal.fire({
        html: '<div style="color:blue;"> Loading... </div>',
        showConfirmButton: false,
      });
    };
    loading();

    const res = await axios
      .post(`${BASE_URL}student/submitexam.php`, data)
      .then((res) => {
        if (res?.data) {
          let isExternal = false;
          if (
            !userName?.includes("ivyis") &&
            !userName?.includes("iatseg") &&
            !userName?.includes("ics")
          ) {
            isExternal = true;
          }
          Swal.fire({
            icon: "success",
            title: "Success",
            text: res.data.msg,
            didOpen: () => {
              const okButton = Swal.getConfirmButton();
              if (okButton) {
                okButton.id = "examOkButtonId";
              }
            },
            allowOutsideClick: false,
            showConfirmButton: isExternal,
          }).then(() => {
            // onConfirm();
          });
        } else {
          // Handle case where res.data is null/undefined
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "No response data received",
          });
        }
      })
      .catch((err) => {
        Swal.close();

        // 🔥 Add this to see the error details
        console.error("Submit error:", err);

        Swal.fire({
          icon: "error",
          title:
            "Please check your internet and try again please don't close the window or the application otherwise your answers will be lost.",
          html: data.msg,
          allowOutsideClick: true,
          showConfirmButton: true,
          showCancelButton: false,
        }).then(() => {
          if (!navigator.onLine || err.message === "Network Error") {
            setState((x: any) => ({ ...x, tryTosubmit: false }));
            setTimeout(() => StudentSubmiteExam(data), 2000);
          }
        });
      });
  };

  const onSaveQuestionHandler = (question: any) => {
    let tempQuestins = [...state.questions];
    let q = tempQuestins.find((q: any) => q.id == question.id);
    let updatedQuestions: any[];

    if (q) {
      let questions = [...tempQuestins];
      let index = questions.indexOf(q);
      questions[index] = question;
      updatedQuestions = questions;

      setState((x: any) => ({ ...x, questions: questions }));
    } else {
      updatedQuestions = tempQuestins.concat(question);
      setState((x: any) => ({
        ...x,
        questions: updatedQuestions,
      }));
    }

    // Set window.questionsPayload with all exam questions
    (window as any).questionsPayload = updatedQuestions;
  };
  const onSaveQuestion = (q: any) => {
    onSaveQuestionHandler(q);
  };
  const submitExam = (val: any = "nothing") => {
    setState((x: any) => ({ ...x, tryTosubmit: true }));

    Swal.fire({
      title: "Submit Assessment",
      html: "Are you sure?<br/> Please note that, this action can not be undone!!",
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: "#3085d6",
      didOpen: () => {
        const okButton = Swal.getConfirmButton();
        if (okButton) {
          okButton.id = "submitAssessmentOkButton";
        }
      },
    }).then((x: any) => {
      if (x.isConfirmed) {
        Swal.showLoading();
        const data = {
          id: state?.assessment.id,
          questions: state.questions,
        };
        // console.log("data", state.assessment);
        StudentSubmiteExam(data);
        localStorage.setItem("fexam", "");
        localStorage.setItem("key", "");

        // window.open(window.location.origin, "_self");
      } else {
        //handleFullScreenClick()
        setState((x: any) => ({ ...x, tryTosubmit: false }));
      }
    });
  };

  const getFingerprint = async () => {
    // First, check if we have device info from the mobile app (directly from window)
    // This is more reliable than using React state due to async timing issues
    const mobileDeviceInfo = (window as any)?.assessgo?.deviceFingerPrint;

    if (mobileDeviceInfo) {
      try {
        const parsedInfo =
          typeof mobileDeviceInfo === "string"
            ? JSON.parse(mobileDeviceInfo)
            : mobileDeviceInfo;
        // console.log(
        //   "📱 getFingerprint - Using mobile app fingerprint:",
        //   parsedInfo
        // );
        return parsedInfo;
      } catch (error) {
        console.error(
          "❌ getFingerprint - Error parsing mobile fingerprint:",
          error,
        );
      }
    }

    // Also check React state as fallback
    if (applicationDeviceInfo) {
      // console.log(
      //   "📱 getFingerprint - Using state applicationDeviceInfo:",
      //   applicationDeviceInfo
      // );
      return applicationDeviceInfo;
    }

    // Fallback to browser fingerprint
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    const browser = Bowser.getParser(window.navigator.userAgent);
    const browserName = browser.getBrowserName();
    const osName = browser.getOSName();
    const osVersion = browser.getOSVersion();
    const platform = browser.getPlatformType();

    const browserInfo = {
      environment: browserName,
      osName: osName,
      osVersion: osVersion,
      platform: platform,
      visitorId: result.visitorId,
      components: result.components,
      windowWidth: windowWidth,
      windowHeight: windowHeight,
    };

    // console.log("🌐 getFingerprint - Using browser fingerprint:", browserInfo);
    return browserInfo;
  };

  const StudentStartExam = async (assessment: any) => {
    const fingerprint = await getFingerprint();
    // let TimeExamStarted=new Date().toISOString();
    axios
      .post(`${BASE_URL}student/startexam.php`, {
        id: assessment.id,
        fingerprint: fingerprint,
      })
      .then((res) => {
        // console.log("the assessment sent to the start exam", assessment);
        let tempAssessment = { ...assessment };
        tempAssessment.status = "Started";
        // console.log("tempAssessment", tempAssessment);

        // Fetch questions and passages after starting the exam (encoded for security)
        axios
          .post(`${BASE_URL}admin/getstudentexamquestionsandpassages.php`, {
            id: id,
          })
          .then((questionsRes) => {
            const examData = questionsRes.data.data;

            // Decode base64 encoded questions and passages
            const decodedQuestions = examData.questions
              ? JSON.parse(base64ToString(examData.questions))
              : [];
            const decodedPassages = examData.passages
              ? JSON.parse(base64ToString(examData.passages))
              : [];

            tempAssessment.questions = decodedQuestions;
            tempAssessment.passages = decodedPassages;

            setState((x: any) => ({
              ...x,
              assessment: tempAssessment,
              questions: decodedQuestions,
              isInite: false,
            }));
          })
          .catch((err) => {
            console.error("Error fetching questions:", err);
            Swal.fire({
              icon: "error",
              title: "Error!",
              html: "Failed to load exam questions. Please try again or contact your teacher.",
              allowOutsideClick: false,
            });
          });
      })
      .catch((err) => {
        console.error("Error starting exam:", err);
        Swal.fire({
          icon: "error",
          title: "Error!",
          html: "Failed to start exam. Please try again.",
          allowOutsideClick: false,
        });
      });
  };
  const silentSubmitExam = async (assessmentData: any) => {
    Swal.showLoading();

    const data = {
      id: assessmentData?.assessment?.id,
      questions: assessmentData.questions,
    };
    StudentSubmiteExam(data);
    localStorage.setItem("fexam", "");
    localStorage.setItem("key", "");

    // Take a screenshot of the current page before showing the alert
    try {
      // Use html2canvas to capture the entire body
      const html2canvas = (await import("html2canvas")).default;
      const canvas = await html2canvas(document.body, {
        allowTaint: true,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      // Convert canvas to blob and download
      // const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      // canvas.toBlob((blob) => {
      //   if (blob) {
      //     const url = URL.createObjectURL(blob);
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.download = `exam-violation-${assessmentData?.assessment?.id}-${timestamp}.png`;
      //     link.click();

      //     setTimeout(() => URL.revokeObjectURL(url), 100);
      //   }
      // }, "image/png");
    } catch (error) {
      console.error("Screenshot capture error:", error);
    }

    // Play beep sound repeatedly every 1.5 seconds using Web Audio API
    try {
      const audioContext = new (
        window.AudioContext || (window as any).webkitAudioContext
      )();

      const playBeep = () => {
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);

        oscillator.frequency.value = 800; // Frequency in Hz
        oscillator.type = "sine";

        gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(
          0.01,
          audioContext.currentTime + 0.5,
        );

        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.5);
      };

      // Play beep immediately
      playBeep();

      // Play beep every 1.5 seconds
      const beepInterval = setInterval(() => {
        playBeep();
      }, 1500);

      (window as any).examViolationBeepInterval = beepInterval;
    } catch (e) {
      console.error("Could not play beep sound:", e);
    }

    // Freeze screen with overlay
    const overlay = document.createElement("div");
    overlay.id = "exam-freeze-overlay";
    overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: 99999;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    `;

    const warningBox = document.createElement("div");
    warningBox.style.cssText = `
        background-color: #fff;
        padding: 40px;
        border-radius: 10px;
        text-align: center;
        max-width: 600px;
        box-shadow: 0 0 30px rgba(255, 0, 0, 0.5);
        animation: pulse 2s infinite;
    `;

    warningBox.innerHTML = `
        <h1 style="color: #dc3545; margin-bottom: 20px; font-size: 2.5rem;"> WARNING </h1>
        <h2 style="color: #333; margin-bottom: 20px;">Your exam has been submitted due to leaving the secure exam environment.</h2>
        <p style="color: #666; font-size: 1.2rem;">Please contact your teacher if you believe this was an error.</p>
        <p style="color: #999; margin-top: 30px;">You may now close this window.</p>
    `;

    overlay.appendChild(warningBox);

    // Add pulsing animation
    const style = document.createElement("style");
    style.textContent = `
        @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
        }
    `;
    document.head.appendChild(style);

    document.body.appendChild(overlay);

    // Disable all interactions
    document.body.style.pointerEvents = "none";
    overlay.style.pointerEvents = "auto";
  };

  const generateNewQuestion = (student_exam_id: any) => {
    if (state.questions.length == 5) {
      document.exitFullscreen();
      Swal.fire({
        icon: "success",
        title: "Finished",
        html: "Thank you for taking the placement test",
        allowOutsideClick: false,
        showConfirmButton: false,
        showCancelButton: false,
        // confirmButtonText :"End"
      }).then((x: any) => {
        // this.examContainerRef.current.classList.remove('hide-element')
      });
    } else {
      Swal.showLoading();
      axios
        .post(BASE_URL + "admin/generatequestion.php", { id: student_exam_id })
        .then((res) => {
          Swal.close();

          onSaveQuestionHandler(res.data.data);
        })
        .catch((err) => {
          Swal.fire(err.response.data.msg, "", "error");
        });
    }
  };
  const getMinutes = () => {
    let m = $("#TMinutes").text();
    return parseInt(m) ?? 0;
  };
  const getSeconds = () => {
    let m = $("#TSeconds").text();
    return parseInt(m) ?? 0;
  };
  const countDown = () => {
    let minutes = getMinutes();
    let seconds = getSeconds();
    seconds = seconds - 1;
    if (seconds === -1) {
      minutes = minutes - 1;

      if (minutes === -1) {
        setCountHasFinished(true);

        silentSubmitExam(stateRef?.current);
        $("#TMinutes").text(TwoDF(0));
        $("#TSeconds").text(TwoDF(0));
        return;
      }
      seconds = 59;
    }
    if (minutes === 0) {
      $("#TSeconds").css("color", "red");
    }
    $("#TMinutes").text(TwoDF(minutes));
    $("#TSeconds").text(TwoDF(seconds));
    setTimeout(() => countDown(), 1000);
  };

  const TwoDF = (n: number) => {
    if (n <= 9) {
      return `0${n}`;
    } else {
      return `${n}`;
    }
  };
  const SetTimer = (t: number) => {
    $("#TMinutes").text(TwoDF(t));
    $("#TSeconds").text("01");
    countDown();
  };
  let token: any = Cookies.get("tokentest");
  let decodedToken: any = jwt_decode(token || "");
  let userName = decodedToken.data.data.userName;

  //examMode
  //gradingModeTeacher
  //gradingModeStudent
  const editQuestionsRenderer = (s: any, q: any, index: any) => {
    q.mode = examMode;
    switch (s) {
      case "MCQ":
        return (
          <MCQ
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "OrderComponent":
        return (
          <OrderComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "MatchQComponent":
        return (
          <MatchQComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "ProcessCard":
        return (
          <ProcessCardSingleState
            type={"ProcessCard"}
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "ProductCard":
        return (
          <ProcessCardSingleState
            type={"ProductCard"}
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "LabelQComponent":
        return (
          <LabelQComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "TrueOrFalse":
        return (
          <TrueOrFalse
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "EssayComponent":
        return (
          <EssayComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "VideoComponent":
        q.showRecordingOpt = true;
        return (
          <VideoComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "AudioComponent":
        return (
          <AudioComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "FileUploadEnhanced":
        return (
          <FileUploadEnhanced
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "FillTheBlank":
        return (
          <FillTheBlank
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "ImageHighlight":
        return (
          <ImageHighlightComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id,
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      default:
        return null;
    }
  };

  const handleBeforeUnload = (event: any) => {
    submitExam();
    event.preventDefault();
    return "are you sure";
  };

  let examsArr: any = [];

  if (state.exam_start && !state.tryTosubmit) {
    examsArr = state.questions?.map((q: any, index: number) => {
      return (
        <React.Fragment key={index}>
          {editQuestionsRenderer(q.type, q, index + 1)}
        </React.Fragment>
      );
    });
  }

  const onConfirm = () => {
    window.close();
  };

  if (state.assessment === null) {
    return (
      <div className="text-center">
        <h3>
          No Valid Access!, Please Click on the Assessment link from the LMS.
        </h3>
      </div>
    );
  }

  return state.assessment != null ? (
    <MathJax>
      <div>
        <div
          className="position-fixed "
          style={{ fontSize: "55px", fontFamily: "Digital" }}
        >
          <span
            id="TMinutes"
            style={{ borderRadius: "8px", background: "#c0c7cd" }}
          >
            00
          </span>
          <span>:</span>
          <span
            id="TSeconds"
            style={{ borderRadius: "8px", background: "#c0c7cd" }}
          >
            00
          </span>
        </div>
        <div className=" d-flex d-md-block flex-nowrap wrapper ">
          <div
            ref={examContainerRef}
            className="hide-element col-md-9 float-center mx-auto pl-md-2 pt-2 main"
          >
            <div>
              <div
                className="col-12 mx-auto align-items-center rounded  text-white "
                style={{ marginTop: "100px" }}
              >
                <h3 className="text-shadow mt-2 ml-3 text-ivyblue">
                  {state.assessment?.name} :{" "}
                </h3>

                {state.assessment?.etype == "benchmark" ? (
                  <>
                    {examsArr[examsArr?.length - 1]}
                    <div
                      style={{
                        marginTop: "1rem",
                        display: "flex",
                        gap: ".5rem",
                        justifyContent: "flex-end",
                      }}
                    >
                      <h3
                        onClick={() => {
                          generateNewQuestion(state.assessment?.id);
                        }}
                        className="btn btn-success"
                      >
                        Next
                      </h3>
                    </div>
                  </>
                ) : (
                  <MultiStepFunc
                    examsArr={examsArr}
                    buttonRef={buttonRef}
                  ></MultiStepFunc>
                )}

                {state.assessment?.status === "Started" &&
                state.assessment.etype != "benchmark" ? (
                  <div className="text-center my-5 ">
                    <button
                      className="btn btn-warning text-white w-100"
                      onClick={submitExam}
                      ref={buttonRef}
                      // disabled={true}
                    >
                      Submit exam
                    </button>
                  </div>
                ) : null}

                <button
                  style={{ visibility: "hidden" }}
                  id="submitExamFromMobile"
                  onClick={() => {
                    silentSubmitExam(stateRef?.current);
                  }}
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MathJax>
  ) : (
    <MathJax>
      <div className="d-flex justify-content-center align-items-center mt-5">
        <Loader type="ThreeDots" color="#00BFFF" height={100} width={100} />
      </div>
    </MathJax>
  );
};

export default StudentAssessment;
